import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React, { useEffect } from 'react';
import moment from 'moment';
import { EntitlementGrantorType } from '../../../interfaces';
import { Button } from '../../../subkit-ui';
import { useSignupProvider } from '../../../hooks/useSignupProvider';
import { http } from '../../../services/http';
import { bookingCreated } from '../../../utils/segmentAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWBookNow = function TWBookNow(_ref) {
  var session = _ref.session,
      createBooking = _ref.createBooking,
      createSessionOrder = _ref.createSessionOrder,
      getUserSessionBookings = _ref.getUserSessionBookings,
      existingBooking = _ref.existingBooking,
      currentUser = _ref.currentUser,
      sessionAccess = _ref.sessionAccess;

  var _useSignupProvider = useSignupProvider(),
      doSignup = _useSignupProvider.doSignup;

  useEffect(function () {
    if (currentUser) getUserSessionBookings(session.id);
  }, [session.id, currentUser]);

  var handleButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _existingServiceSubsc, _existingServiceSubsc2;

      var providerService, startsAt, endsAt, sessionId, existingServiceSubscription, redirect, order;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (currentUser) {
                _context.next = 3;
                break;
              }

              doSignup(encodeURIComponent(window.location.origin + window.location.pathname));
              return _context.abrupt("return");

            case 3:
              providerService = session.providerService, startsAt = session.startsAt, endsAt = session.endsAt, sessionId = session.id;

              if (!(sessionAccess !== null && sessionAccess !== void 0 && sessionAccess.serviceId)) {
                _context.next = 8;
                break;
              }

              _context.next = 7;
              return http.get("provider-service/".concat(sessionAccess.serviceId, "/user-subscriptions"));

            case 7:
              existingServiceSubscription = _context.sent;

            case 8:
              // Check if user has an existing service subscription
              // If so, they have already consented to terms of the service and don't require to go to checkout
              // Otherwise redirect to checkout, record consent and create a service prospect if one doesn't already exist
              redirect = (_existingServiceSubsc = existingServiceSubscription.data) !== null && _existingServiceSubsc !== void 0 && _existingServiceSubsc.id ? false : true;
              _context.next = 11;
              return createSessionOrder({
                startsAt: startsAt,
                endsAt: endsAt,
                sessionId: sessionId
              }, redirect);

            case 11:
              order = _context.sent;

              if (!((_existingServiceSubsc2 = existingServiceSubscription.data) !== null && _existingServiceSubsc2 !== void 0 && _existingServiceSubsc2.id)) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return createBooking({
                serviceId: sessionAccess.serviceId,
                sessionId: session.id,
                orderId: order.id,
                attendees: 1
              }).then(function (booking) {
                var serviceId = sessionAccess.serviceId;
                booking && bookingCreated({
                  booking: booking,
                  serviceId: serviceId,
                  session: session,
                  providerService: providerService
                });
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleButtonClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var bookingDate = existingBooking ? moment(existingBooking.createdAt).format('MMMM D, yyyy') : '';
  if (existingBooking && existingBooking.status === 'active') return /*#__PURE__*/_jsx("div", {
    className: "block",
    children: /*#__PURE__*/_jsxs("div", {
      className: "rounded box-shadow p-4 w-full",
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-0 bold",
        children: "You're all set!"
      }), /*#__PURE__*/_jsxs("p", {
        className: "m-0 text-base text-gray-500",
        children: ["You booked this session on ", bookingDate, " "]
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: /*#__PURE__*/_jsx(Button, {
          type: "secondary",
          text: "View Details",
          href: "/bookings/".concat(existingBooking.id),
          size: "lg",
          iconType: "solid"
        })
      })]
    })
  });
  return /*#__PURE__*/_jsx("div", {
    className: "block",
    children: /*#__PURE__*/_jsxs("div", {
      className: "rounded box-shadow p-4 w-full",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between",
        children: [/*#__PURE__*/_jsx("p", {
          className: "m-0 bold",
          children: "Individual Session"
        }), /*#__PURE__*/_jsx("p", {
          className: "m-0",
          children: "Free"
        })]
      }), (sessionAccess === null || sessionAccess === void 0 ? void 0 : sessionAccess.grantorType) === EntitlementGrantorType.PRICE && /*#__PURE__*/_jsx("p", {
        className: "m-0 text-base text-gray-500",
        children: "This is included in your subscription."
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: /*#__PURE__*/_jsx(Button, {
          text: "Book Now",
          loadingText: "Booking...",
          size: "lg",
          onClick: handleButtonClick
        })
      })]
    })
  });
};